<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <div class="flex -mx-2 text-4xl font-bold">
        <router-link to="/af/apotek" class="px-4 text-red-400">Apotek</router-link>
        <router-link to="/af/kjeder" class="px-4 text-red-500"><div class="border-b-2 border-red-500">Kjeder</div></router-link>
      </div>
      <div class="flex items-center">
        <search-input v-model="search"></search-input>
        <router-link class="ml-6 btn btn-primary" to="kjeder/opprett">Ny kjede</router-link>
        <a href="#" @click.prevent="onDelete" class="ml-4 btn btn-primary" v-if="selected.length > 0">
          <font-awesome-icon :icon="['far', 'trash']" />
        </a>
      </div>
    </div>
    <panel>
      <data-table
        :headers="headers"
        :items="chains"
        :search="search"
        :showSelect="true"
        identifier="chainId"
        v-model="selected"
        v-if="isReady"
        @click="onClick">
        <template v-slot:item.chain="{ item }">
          {{ item.name }}
        </template>
      </data-table>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
// import { mapGetters } from 'vuex'
export default {
  name: 'ap-chain-list',
  data () {
    return {
      isReady: false,
      search: '',
      selected: [],
      headers: [
        { text: 'Navn', align: 'left', value: 'name' },
        { text: 'Antall apotek', align: 'left', value: 'pharmacyCount' },
      ],
      chains: []
    }
  },
  methods: {
    onClick (chain) {
      if (chain.chainId) {
        this.$router.push('/af/kjeder/' + chain.chainId)
      }
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].chainId) {
          await api.af.deleteChain(this.selected[i].chainId)
        }
      }
      this.chains = await api.af.getChains()
    }
  },
  async created () {
    this.chains = await api.af.getChains()
    this.isReady = true
  }
}
</script>

